import { render, staticRenderFns } from "./liveCommerce.vue?vue&type=template&id=ebc19e94&scoped=true"
import script from "./liveCommerce.vue?vue&type=script&lang=js"
export * from "./liveCommerce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc19e94",
  null
  
)

export default component.exports